import React, { Component, useEffect } from 'react';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isEmpty from 'lodash/isEmpty';
import { createAction } from 'redux-actions';
import { bindActionCreators } from 'redux';
import { Section } from './Form';
import { connect } from 'react-redux';
import styles from './Form.scss';

const flattenErrors = function* (errors, route = []) {
  if (isArray(errors)) {
    for (let index = 0; index < errors.length; index++) {
      yield* flattenErrors(errors[index], [{ index, errors }, ...route]);
    }
  } else {
    for (let key in errors) {
      const value = errors[key];
      if (isObject(value)) {
        // object or array
        yield* flattenErrors(value, [{ key, errors }, ...route]);
      } else {
        yield { value, route: [{ key, errors }, ...route] };
      }
    }
  }
};

const findParentIndex = (items, from) => {
  for (let index = from; index < items.length; index++) {
    if (items[index] && items[index].key) {
      return index;
    }
  }
  return items.length;
};

const eachWithParentKey = function* (items) {
  let parentIndex = 0;
  for (let index = 0; index < items.length; index++) {
    if (parentIndex <= index) {
      parentIndex = findParentIndex(items, parentIndex + 1);
    }
    yield [items[index], items[parentIndex] && items[parentIndex].key];
  }
};

const makeMessageParts = (route, fields, acceptParent) => {
  if (acceptParent) {
    const findParent = [...eachWithParentKey(route)];
    const findFieldMessage = findParent.map(([{ index, key, errors }, parentKey]) => {
      if (isArray(errors)) {
        return `${index + 1}番目の`;
      }
      if (parentKey && fields[`${parentKey}.${key}`]) {
        return fields[`${parentKey}.${key}`];
      }
      if (fields[key]) {
        return fields[key];
      }
      if (!isNaN(Number(key))) {
        return `${Number(key) + 1}番目の`;
      }
      return key;
    });
    return findFieldMessage;
  } else {
    return route.map(({ index, key, errors }) => {
      if (isArray(errors)) {
        return `${index + 1}番目の`;
      }
      if (fields[key]) {
        return fields[key];
      }
      if (!isNaN(Number(key))) {
        return `${Number(key) + 1}番目の`;
      }
      return key;
    });
  }
};

const getErrorMessages = function* (errors, fields, acceptParent) {
  for (let error of errors) {
    const { value, route } = error;
    const name = route
      .map(({ index, key, errors }) => (isArray(errors) ? `[${index}]` : `.${key}`))
      .reverse()
      .join('');
    const message = makeMessageParts(route, fields, acceptParent).reverse().join('') + value;
    yield { name, message };
  }
};

export const onSubmitFail = (errors, dispatch) => {
  const errorList = [...flattenErrors(errors)];
  dispatch(setErrors(errorList));
};

class FormErrors extends Component {
  componentWillUnmount() {
    this.props.reset();
  }

  componentDidUpdate(prevProps) {
    if (this.props.errors !== prevProps.errors && !isEmpty(this.props.errors)) {
      this._main.scrollIntoView();
    }
  }

  render() {
    const { errors, fields, acceptParent = false } = this.props;
    const messages = [...getErrorMessages(errors, fields, acceptParent)];
    return (
      <div ref={div => (this._main = div)}>
        {!isEmpty(messages) && (
          <Section title="入力内容に誤りがあります" error>
            <ul className={styles.errorHead}>
              {messages.map(({ name, message }) => (
                <li key={name}>{message}</li>
              ))}
            </ul>
          </Section>
        )}
      </div>
    );
  }
}

const LabelMapperComonent = ({ addField, name, label }) => {
  useEffect(() => {
    addField({ [name]: label });
  }, [name, label]);

  return null;
};

const SET_ERRORS = 'FORM_ERRORS/SET_ERRORS';
const ADD_FIELD = 'FORM_ERRORS/ADD_FIELD';
const RESET = 'FORM_ERRORS/RESET';

const setErrors = createAction(SET_ERRORS);
const addField = createAction(ADD_FIELD);
const reset = createAction(RESET);

const initialState = {
  errors: [],
  fields: {},
};

export const LabelMapper = connect(null, bindActionCreators.bind(null, { addField }))(LabelMapperComonent);

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ERRORS:
      return { ...state, errors: action.payload };
    case ADD_FIELD:
      return { ...state, fields: { ...state.fields, ...action.payload } };
    case RESET:
      return { ...state, errors: initialState.errors };
    default:
      return state;
  }
};

export default connect(state => state.formErrors, bindActionCreators.bind(null, { reset }))(FormErrors);
